// eslint-disable-next-line import/prefer-default-export
export const getMinDate = (buffer) => {
  const date = new Date();
  date.setMinutes(date.getMinutes() + buffer);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

export {
  parseDateForApi,
  getFormatDateFromValue,
} from "src/Pages/Company/CompanyBanks/Management/Edit/Shared/utils/dateUtils";
